import Link from "next/link";

import Image from "@/components/Image";

function DeejayThumbnail({ dj }) {
  return (
    <div className="card shadow">
      <div className="row g-0">
        <div className="col-md-4">
          <Image
            src={dj.pic ? dj.pic : "/static/main/images/defaultAvatar.jpg"}
            width={225}
            height={225}
            alt={dj.dj}
            className="card-img"
            layout="responsive"
          />
        </div>
        <div className="col-md-8">
          <div className="card-body">
            <p className="card-text text-white">
              <Link href={dj.url}>
                <a className="stretched-link">
                  <b>{dj.dj.toUpperCase()}</b>
                </a>
              </Link>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DeejayThumbnail;
